import { createContext, useContext, useReducer } from "react";

const initialState = {
  showNavigation: false,
  showSearch: false,
  showUserNavigation: false,
  currentPageId: null,
  navigationLevel: 1,
  breadcrumb: [],
};

function reducer(state, action) {
  switch (action.type) {
    case "addToBreadcrumb":
      if (state.breadcrumb.slice(-1)[0] === action.payload) return state;
      return { ...state, breadcrumb: [...state.breadcrumb, action.payload] };
    case "removeFromBreadcrumb":
      return { ...state, breadcrumb: state.breadcrumb.slice(0, -1) };
    case "updateCurrentPageId":
      return {
        ...state,
        currentPageId: action.payload.pageId,
        navigationLevel: parseInt(action.payload.navLevel, 10),
      };
    case "toggleNavigation": {
      const { field, value } = action.payload;
      const next = {};
      ["showNavigation", "showSearch", "showUserNavigation"].forEach((key) => {
        next[key] = key === field ? value : false;
      });
      return { ...state, ...next };
    }
    default:
      return state;
  }
}

const MobileNavigationContext = createContext();

export function MobileNavigationProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <MobileNavigationContext.Provider value={{ ...state, dispatch }}>
      {children}
    </MobileNavigationContext.Provider>
  );
}

export function useMobileNavigation() {
  const context = useContext(MobileNavigationContext);
  if (!context) {
    throw new Error(
      "useMobileNavigation must be used within a MobileNavigationProvider"
    );
  }
  return context;
}
